import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import MobileHeader from './MobileHeader';
import Footer from './Footer';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname, location.search]);

  // Don't show layout on auth pages
  const hideLayout = ['/login', '/register', '/complete-profile'].includes(
    location.pathname
  );

  if (hideLayout) {
    return <>{children}</>;
  }

  return (
    <div className="layout">
      <MobileHeader />
      <Navbar />
      <main className="layout-main">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
